import { canv } from "@/canv/global";
import {
    SHOW_COMMENTS_LS_KEY,
    SHOW_RESOLVED_COMMENTS_LS_KEY,
    SHOW_VOTES_RESULTS_LS_KEY,
} from "@/constants";

export function setViewWidgetsSettingsFromLS() {
    let showCommentsFlag = null;
    let showResolvedCommentsFlag = null;
    let showVotesResultsFlag = null;

    try {
        showCommentsFlag = getItem(SHOW_COMMENTS_LS_KEY);
        showResolvedCommentsFlag = getItem(SHOW_RESOLVED_COMMENTS_LS_KEY);
        showVotesResultsFlag = getItem(SHOW_VOTES_RESULTS_LS_KEY);
    } catch (err) {
        console.error("Ошибка получения настроек отображения комментариев или голосований", err);

        canv.captureException(err);
    }

    setViewSettings(SHOW_COMMENTS_LS_KEY, showCommentsFlag);
    setViewSettings(SHOW_RESOLVED_COMMENTS_LS_KEY, showResolvedCommentsFlag);
    setViewSettings(SHOW_VOTES_RESULTS_LS_KEY, showVotesResultsFlag);
}

function getItem(key: string) {
    const res = localStorage.getItem(key);

    if (res === null) {
        return null;
    }

    return JSON.parse(res);
}

export function setViewSettings(name: string, value: unknown) {
    if (value === null || typeof value !== "boolean") {
        localStorage.setItem(name, "true");
        canv.canvasController[name] = true;
    } else {
        localStorage.setItem(name, JSON.stringify(value));
        canv.canvasController[name] = value;
    }
}
